<template>
  <v-card align="center" justify="center" max-width="56vw" min-width="30vw" outlined>
    <v-card-title >
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title_AddTournament') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="py-7">
      <v-overlay :dark="false" :absolute="true" :value="overlayProcessing" ><v-progress-circular :size="70" width="5" indeterminate/></v-overlay>
      <v-stepper v-model="step" class="elevation-0">
        <v-stepper-header class="elevation-0">
          <v-stepper-step :color="`#${$store.state.clubMember.club.primaryColor}`" :complete="step > 1" step="1">{{ $t('steps.basic') }}</v-stepper-step>
          <v-stepper-step :color="`#${$store.state.clubMember.club.primaryColor}`" :complete="step > 2" step="2">{{ $t('steps.details') }}</v-stepper-step>
          <v-stepper-step :color="`#${$store.state.clubMember.club.primaryColor}`" :complete="step > 3" step="3">{{ $t('steps.rules') }}</v-stepper-step>
          <v-stepper-step :color="`#${$store.state.clubMember.club.primaryColor}`" :complete="step > 4" step="4">{{ $t('steps.awards') }}</v-stepper-step>
          <v-stepper-step :color="`#${$store.state.clubMember.club.primaryColor}`" :complete="step > 5" step="5">{{ $t('steps.confirmation') }}</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items class="mt-n5">
          <v-stepper-content step="1">
            <v-form v-model="validOne">
              <p class="text-center mb-7">{{ $t('basic.message') }}</p>
              <v-text-field :label="$t('basic.labelName')" :placeholder="$t('basic.placeholderName', { name: this.$store.state.clubMember.club.name })"
                            v-model="tournamentName" :rules="tournamentNameRules" counter="45" outlined/>
              <div class="d-flex align-center">
                <v-menu :close-on-content-click="false" offset-y transition="scale-transition" v-model="menuDates">
                  <template v-slot:activator="{ on }">
                    <v-text-field :label="$t('basic.labelDates')" outlined persistent-hint readonly v-model="datesRangeText" :rules="dateRules" v-on="on"/>
                  </template>
                  <v-date-picker @input="inputDates" range no-title v-model="tournamentDates"/>
                </v-menu>
                <v-select :items="platforms" :label="$t('basic.labelPlatform')" class="ml-3" v-model="tournamentPlatform" :rules="tournamentNameRules" outlined/>
              </div>
              <v-text-field :label="$t('basic.labelFAQs')" :placeholder="$t('basic.placeholderFAQs', { name: this.$store.state.clubMember.club.name.toLowerCase() })"
                            :hint="$t('basic.hintFAQs')" persistent-hint v-model="tournamentFAQs" :rules="tournamentFAQsRules" counter="100" outlined/>
              <v-btn @click="goNext" :color="`#${$store.state.clubMember.club.primaryColor} !important`" class="mt-7 mb-1">{{ $t('btnNext_AddTournament') }} »</v-btn>
              <v-card v-if="isFeatureUnavailable" class="d-flex align-center justify-center mt-3 rounded-card" color="error">
                <p class="pt-4 white-text">{{ $t('basic.tournamentsLimitReached') }}</p>
                <v-chip class="ml-3" text-color="black" @click="missingFeature">{{ $t('basic.exclusiveFeature') }}</v-chip>
              </v-card>
            </v-form>
          </v-stepper-content>
          <v-stepper-content step="2">
            <div class="d-flex align-center my-2">
              <h4 class="mr-5">{{ $t('details.visibility') }}</h4><v-divider/>
            </div>
            <v-radio-group v-model="tournamentType">
              <v-radio value="PRIVATE">
                <template v-slot:label><div><p class="mb-0 black--text">{{ $t('details.private') }}</p>{{ $t('details.privateDescription') }}</div></template>
              </v-radio>
              <v-radio value="PUBLIC" disabled>
                <template v-slot:label><div><p class="mb-0 black--text">{{ $t('details.public') }}<strong class="success--text">({{ $t('details.soon') }})</strong></p>{{ $t('details.publicDescription') }}</div></template>
              </v-radio>
              <v-radio value="EXCLUSIVE" disabled>
                <template v-slot:label><div><p class="mb-0 black--text">{{ $t('details.exclusive') }}<strong class="success--text">({{ $t('details.soon') }})</strong></p>{{ $t('details.exclusiveDescription') }}</div></template>
              </v-radio>
            </v-radio-group>
            <div class="d-flex align-center my-2">
              <h4 class="mr-5">{{ $t('details.rankType') }}</h4><v-divider/>
            </div>
            <v-radio-group v-model="tournamentRanking">
              <v-radio value="SWISET_RATIO">
                <template v-slot:label><div><p class="mb-0 black--text">{{ $t('details.swisetRatio') }} <strong class="success--text">({{ $t('details.recommended') }})</strong></p>{{ $t('details.swisetRatioDescription') }}</div></template>
              </v-radio>
              <v-radio value="BALANCE">
                <template v-slot:label><div><p class="mb-0 black--text">{{ $t('details.balance') }}</p>{{ $t('details.balanceDescription') }}</div></template>
              </v-radio>
            </v-radio-group>
            <div class="d-flex align-center justify-center mt-7 mb-1">
              <v-btn @click="goBack" :color="`#${$store.state.clubMember.club.primaryColor} !important`">« {{ $t('btnBack_AddTournament') }}</v-btn>
              <v-btn class="ml-3" :color="`#${$store.state.clubMember.club.primaryColor} !important`" @click="goNext">{{ $t('btnNext_AddTournament') }} »</v-btn>
            </div>
          </v-stepper-content>
          <v-stepper-content step="3">
            <v-form v-model="validThree">
              <p class="text-center mb-7">{{ $t('rules_AddTournament.message') }}</p>
              <div class="d-flex align-center justify-start mt-2">
                <h4 class="text-start">{{ $t('rules_AddTournament.initialBalance') }}<br><span>{{ $t('rules_AddTournament.initialBalanceDescription') }}</span></h4>
                <v-switch v-model="initialBalance" class="ml-4" inset :label="`${this.$t((initialBalance)? 'rules_AddTournament.selected' : 'rules_AddTournament.notSelected')}`"/>
                <v-text-field v-if="initialBalance" class="ml-5 mt-0 mb-n7" :label="$t('rules_AddTournament.initialBalance')" placeholder="E.g. 1000" type="number" v-model="initialBalanceNumber" dense outlined/>
              </div>
              <div class="d-flex align-center justify-start mt-2">
                <h4 class="text-start">{{ $t('rules_AddTournament.minDays') }} <strong class="success--text">({{ $t('details.recommended') }})</strong><br><span>{{ $t('rules_AddTournament.minDaysDescription') }}</span></h4>
                <v-switch v-model="minDaysTrading" class="ml-4" inset :label="`${this.$t((minDaysTrading)? 'rules_AddTournament.selected' : 'rules_AddTournament.notSelected')}`"/>
                <v-text-field v-if="minDaysTrading" class="ml-5 mt-0 mb-n7" :label="$t('rules_AddTournament.minDays')" placeholder="E.g. 15" type="number" v-model="minDaysTradingNumber" dense outlined/>
              </div>
              <div class="d-flex align-center justify-start mt-2">
                <h4 class="text-start">{{ $t('rules_AddTournament.consistency') }} <strong class="success--text">({{ $t('details.recommended') }})</strong><br><span>{{ $t('rules_AddTournament.consistencyDescription') }}</span></h4>
                <v-switch v-model="consistency" class="ml-4" inset :label="`${this.$t((consistency)? 'rules_AddTournament.selected' : 'rules_AddTournament.notSelected')}`"/>
              </div>
              <div class="d-flex align-center justify-start mt-2">
                <h4 class="text-start">{{ $t('rules_AddTournament.maxTradeSize') }}<br><span>{{ $t('rules_AddTournament.maxTradeSizeDescription') }}</span></h4>
                <v-switch v-if="tournamentPlatform === 'NinjaTrader'" v-model="maxTradeSize" class="ml-4" inset :label="`${this.$t((maxTradeSize)? 'rules_AddTournament.selected' : 'rules_AddTournament.notSelected')}`"/>
                <v-chip v-else class="ml-4 my-5" small>{{ $t('rules_AddTournament.onlyFor', { platform: 'NinjaTrader' }) }}</v-chip>
                <v-text-field v-if="maxTradeSize" class="ml-5 mt-0 mb-n7" :label="$t('rules_AddTournament.maxTradeSize')" placeholder="E.g. 5 contracts" type="number" v-model="maxTradeSizeNumber" dense outlined/>
              </div>
              <div class="d-flex align-center justify-start mt-2">
                <h4 class="text-start">{{ $t('rules_AddTournament.maxLoss') }}<br><span>{{ $t('rules_AddTournament.maxLossDescription') }}</span></h4>
                <v-switch v-if="tournamentPlatform === 'NinjaTrader'" v-model="maxMAE" class="ml-4" inset :label="`${this.$t((maxMAE)? 'rules_AddTournament.selected' : 'rules_AddTournament.notSelected')}`"/>
                <v-chip v-else class="ml-4 my-5" small>{{ $t('rules_AddTournament.onlyFor', { platform: 'NinjaTrader' }) }}</v-chip>
                <v-text-field v-if="maxMAE" class="ml-5 mt-0 mb-n7" :label="$t('rules_AddTournament.maxLoss')" placeholder="E.g. 500" type="number" v-model="maxMAENumber" dense outlined/>
              </div>
              <div class="d-flex align-center justify-start mt-2">
                <h4 class="text-start">{{ $t('rules_AddTournament.overnight') }}<br><span>{{ $t('rules_AddTournament.overnightDescription') }}</span></h4>
                <v-switch v-if="tournamentPlatform === 'NinjaTrader'" v-model="overnight" class="ml-4" inset :label="`${this.$t((overnight)? 'rules_AddTournament.withoutOvernight' : 'rules_AddTournament.withOvernight')}`"/>
                <v-chip v-else class="ml-4 my-5" small>{{ $t('rules_AddTournament.onlyFor', { platform: 'NinjaTrader' }) }}</v-chip>
              </div>
              <div class="d-flex align-center justify-start mt-2">
                <v-select :items="accountTypes" :label="$t('rules_AddTournament.accountTypeLabel')" v-model="accountType" :rules="tournamentNameRules" outlined/>
              </div>
              <div class="d-flex align-center justify-center mt-10 mb-1">
                <v-btn @click="goBack" :color="`#${$store.state.clubMember.club.primaryColor} !important`">« {{ $t('btnBack_AddTournament') }}</v-btn>
                <v-btn class="ml-3" @click="goNext" :color="`#${$store.state.clubMember.club.primaryColor} !important`">{{ $t('btnNext_AddTournament') }} »</v-btn>
              </div>
            </v-form>
          </v-stepper-content>
          <v-stepper-content step="4">
            <v-form v-model="validFour">
              <p class="text-center mb-7">{{ $t('awards.message') }}</p>
              <div class="d-flex align-center justify-start mt-0" v-bind:key="award.rankNumber" v-for="award in awards">
                <h3 class="mt-n7">{{ award.rankNumber }}</h3>
                <v-text-field class="ml-3" :label="$t('awards.labelTitle', { position: award.rankNumber })" :placeholder="$t('awards.placeholderTitle')"
                              v-model="award.title" :rules="titleRule" dense outlined/>
                <v-text-field class="ml-2" :label="$t('awards.labelDescription', { position: award.rankNumber })"
                              :placeholder="$t('awards.placeholderDescription')" v-model="award.description" :rules="descriptionRule" dense outlined/>
                <v-icon v-if="award.rankNumber === awards.length && award.rankNumber !== 1" class="mt-n7 icon" style="width: 10%;" @click="DeleteLastAwards" small>fa-trash</v-icon>
              </div>
            </v-form>
            <v-btn style="width: 100%;" @click="AddAward">{{ $t('awards.btnAddAward') }} <v-icon class="ml-2" small>fa-plus</v-icon></v-btn>
            <div class="d-flex align-center justify-center mt-12 mb-1">
              <v-btn @click="goBack" :color="`#${$store.state.clubMember.club.primaryColor} !important`">« {{ $t('btnBack_AddTournament') }}</v-btn>
              <v-btn class="ml-3" @click="goNext" :color="`#${$store.state.clubMember.club.primaryColor} !important`">{{ $t('btnNext_AddTournament') }} »</v-btn>
            </div>
          </v-stepper-content>
          <v-stepper-content step="5">
            <p class="text-center mb-7">{{ $t('confirmation.message') }}</p>
            <v-img class="mb-5" src="https://hub.swiset.com/wp-content/uploads/2021/01/Trading-Tournament.png" max-width="91px" contain/>
            <p class="text-start"><b>{{ $t('confirmation.name') }}:</b> {{ tournamentName }}.</p>
            <p class="text-start" v-if="formalStartDate !== null && formalEndDate !== null"><b>{{ $t('confirmation.dates') }}:</b>
              {{ $t('confirmation.datesText', { from: formalStartDate.toISOString().substr(0, 10), to: formalEndDate.toISOString().substr(0, 10), days: getTournamentDays() }) }}</p>
            <p class="text-start"><b>{{ $t('confirmation.details') }}:</b><v-chip class="ml-2" color="#00F784" small>
              {{ tournamentRanking.replace('_', ' ') }}</v-chip>
              {{ $t('confirmation.detailsTextPrepend') }} <v-chip color="#FFF75F" small>{{ tournamentType }}</v-chip> {{ $t('confirmation.detailsTextAppend') }}</p>
            <p class="text-start"><b>{{ $t('confirmation.rules') }}:</b> {{ $tc('confirmation.rulesText', rules_AddTournament.length, { count: rules_AddTournament.length }) }}</p>
            <p class="text-start"><b>{{ $t('confirmation.awards') }}:</b> {{ awards.length }} {{ $t('confirmation.awardsText') }}</p>
            <div class="d-flex align-center justify-center mt-12 mb-1">
              <v-btn @click="goBack">« {{ $t('btnBack_AddTournament') }}</v-btn>
              <v-btn class="ml-3" @click="createTournament">{{ $t('btnCreate') }}</v-btn>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/tournament';
import { mapMutations } from 'vuex';
export default {
  name: "AddTournament",
  props: {
    featurePermissionInfo: Object
  },
  data() {
    return {
      overlayProcessing: false,
      step: 1,
      validOne: false,
      validThree: false,
      validFour: false,

      // Step 1
      platforms: [
        'NinjaTrader',
        'cTrader',
        'MetaTrader 4',
        'MetaTrader 5',
      ],
      tournamentName: '',
      tournamentDates: [new Date().toISOString().substr(0, 10), new Date().toISOString().substr(0, 10)],
      tournamentPlatform: 'NinjaTrader',
      tournamentFAQs: '',
      menuDates: false,
      formalStartDate: null,
      formalEndDate: null,
      isFeatureUnavailable: false,
      tournamentNameRules: [
          t => !!t || this.$t('basic.ruleName'),
          t => (t && t.length <= 45) || 'Max 45 characters',
      ],
      dateRules: [
          d => !!d || this.$t('basic.ruleDates'),
      ],
      tournamentFAQsRules: [
          f => ((f && f.length <= 100 ) || f.length === 0)  || 'Max 100 characters',
      ],

      // Step 2
      tournamentType: 'PRIVATE',
      tournamentRanking: 'SWISET_RATIO',

      // Step 3
      initialBalance: false,
      initialBalanceNumber: 0,
      consistency: false,
      maxTradeSize: false,
      maxTradeSizeNumber: 0,
      maxMAE: false,
      maxMAENumber: 0,
      minDaysTrading: false,
      minDaysTradingNumber: 0,
      overnight: false,
      rules: [],

      // Step 4
      awards: [ { rankNumber: 1, title: '', description: '' }, ],
      titleRule: [
          t => !!t || this.$t('awards.ruleTitle'),
      ],
      descriptionRule: [
          d => !!d || this.$t('awards.ruleDescription'),
      ],
      accountType: 'DEMO',
      accountTypes: ['DEMO', 'LIVE']
    };
  },
  computed: {
    datesRangeText () {
      return this.tournamentDates.join(` ${this.$t('basic.to')} `);
    },
  },
  methods: {
    goBack() {
      this.step--;
    },
    goNext() {
      if(this.step === 1 && this.validateBasics()) {
        if (this.featurePermissionInfo.unlimited == true) {
          this.step++;
        } else if (this.validateLimitAmountReached()) {
          this.isFeatureUnavailable = true;
        } else {
          this.step++;
        }
      } else if (this.step === 2 || (this.step === 3 && this.validateRules()) || (this.step === 4 && this.validateAwards()))
        this.step++;
    },
    missingFeature() {
      let plan = this.$store.state.clubMember.club.clubPackage.name;
      if(plan == 'Swiset custom') {
        window.open("https://t.me/Swiset", '_blank');
      } else {
        this.$router.push('/subscription-plans-club')
      }
    },
    validateLimitAmountReached() {
      let tournaments = this.$store.state.clubTournaments;
      let amountSelectedMonth = 0;
      let tournamentsLimitReached = false;
      for(let i = 0; i < tournaments.length && !tournamentsLimitReached; i++) {
        if (this.tournamentDates[0].split('-')[0] == tournaments[i].startTime.split('-')[0]  && this.tournamentDates[0].split('-')[1] == tournaments[i].startTime.split('-')[1]) {
          amountSelectedMonth++;
          tournamentsLimitReached = amountSelectedMonth >= this.featurePermissionInfo.amount;
        }
      }
      return tournamentsLimitReached;
    },
    inputDates(){
      if(this.tournamentDates.length === 2)
        this.menuDates = false;
    },
    DeleteLastAwards() {
      this.awards.pop();
    },
    AddAward() {
      this.awards.push( { rankNumber: this.awards.length + 1 , title: '', description: '' } );
    },
    validateBasics() {
      if(this.validOne && this.tournamentDates.length === 2){
        let startDateArray = this.tournamentDates[0].split('-');
        let endDateArray = this.tournamentDates[1].split('-');
        this.formalStartDate = new Date(startDateArray[0], startDateArray[1] - 1, startDateArray[2]);
        this.formalEndDate = new Date(endDateArray[0], endDateArray[1] - 1, endDateArray[2]);

        if(this.formalStartDate >= this.formalEndDate) {
          alert(this.$t('alerts.dateBefore'));
          return false;
        }
        else if(new Date() > this.formalStartDate || new Date() > this.formalEndDate) {
          alert(this.$t('alerts.dateToday'));
          return false;
        }

        return true;
      }
      else
        alert(this.$t('alerts.notFilled'));

      return false;
    },
    validateRules() {
      this.rules = [];
      if(this.tournamentRanking === 'BALANCE' && !this.initialBalance) {
        alert(this.$t('validation.initialBalanceRequired'));
        return false;
      }

      if(this.initialBalance && this.initialBalanceNumber <= 0) {
        alert(this.$t('validation.initialBalanceNumber'));
        return false;
      }

      if(this.consistency)
        this.rules_AddTournament.push({ ruleType: 'CONSISTENCY', value: 0.3 });

      if(this.maxTradeSize && this.maxTradeSizeNumber > 0)
        this.rules_AddTournament.push({ ruleType: 'MAX_TRADE_SIZE', value: this.maxTradeSizeNumber });
      else if(this.maxTradeSize){
        alert(this.$t('validation.tradeSizeNumber'));
        return false;
      }

      if(this.maxMAE && this.maxMAENumber > 0)
        this.rules_AddTournament.push({ ruleType: 'MAX_MAE', value: this.maxMAENumber });
      else if(this.maxMAE){
        alert(this.$t('validation.maxLossNumber'));
        return false;
      }

      if(this.minDaysTrading && this.minDaysTradingNumber > 0)
        this.rules_AddTournament.push({ ruleType: 'MIN_TRADABLE_DAYS', value: this.minDaysTradingNumber });
      else if(this.minDaysTrading){
        alert(this.$t('validation.minDaysNumber'));
        return false;
      }

      if(this.overnight)
        this.rules_AddTournament.push({ ruleType: 'OVERNIGHT', value: 1 });

      return true;
    },
    validateAwards() {
      if(!this.validFour)
        alert(this.$t('alerts.awards'));

      return this.validFour;
    },
    ...mapMutations(['setClubTournaments']),
    createTournament() {
      this.overlayProcessing = true;
      this.formalEndDate.setDate(this.formalEndDate.getDate() + 1);
      let tournament = {
        creator: { id: this.$store.state.clubMember.club.id },
        name: this.tournamentName,
        startTime: this.formalStartDate,
        endTime: this.formalEndDate,
        createdAt: new Date(),
        tournamentRankingType: this.tournamentRanking,
        tournamentVisibility: this.tournamentType,
      }
      if(this.initialBalance)
        tournament.initialBalance = this.initialBalanceNumber;
      if(this.tournamentFAQs !== null && this.tournamentFAQs !== '')
        tournament.faqsUrl = this.tournamentFAQs;

      let fullTournament = {
        tournament: tournament,
        accountType: this.accountType,
        rules: this.rules,
        awards: this.awards,
      };

      Repository.createFullTournament(fullTournament).then((response) => {
        if(response.status < 400) {
          alert(this.$t('alerts.created'));
          Repository.getTournamentsByClubId(this.$store.state.clubMember.club.id).then((secondResponse) => {
            if(secondResponse.status < 400)
              this.setClubTournaments(secondResponse.data);
            this.close();
          });
        }
        else {
          alert('An error occurred :(');
          this.overlayProcessing = false;
        }
      })
    },
    getTournamentDays() {
      if(this.formalStartDate !== null && this.formalEndDate !== null) {
        let Difference_In_Time = this.formalEndDate.getTime() - this.formalStartDate.getTime();
        return Difference_In_Time / (1000 * 3600 * 24);
      }
      return 0;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    close() {
      this.$emit('closeWindow');
    },
  }
}
</script>



<style scoped>

.white-text {
  color: white
}

.rounded-card {
  border-radius:15px
}

</style>
